module.exports = __webpack_public_path__ + "img/zotac.b9d44ee7.jpeg";